import { Check } from "lucide-react";

import { Spinner } from "@/components/ui/spinner";
import { COPILOT_STEP_LABELS, type CopilotToolName } from "@/constants/copilot/copilot-constants";

const isCopilotTool = (name: string): name is CopilotToolName => name in COPILOT_STEP_LABELS;

/**
 * Only the agent's own tools get a line: a call to any other name is a malformed call the model retries, so it
 * isn't shown.
 */
export function CopilotStep({ name, complete }: { name: string; complete: boolean }) {
  if (!isCopilotTool(name)) return null;
  const [inProgress, done] = COPILOT_STEP_LABELS[name];
  return (
    <p className="my-1 flex items-center gap-2 text-xs text-muted-foreground">
      {complete ? <Check className="size-3" /> : <Spinner className="size-3" />}
      {complete ? done : inProgress}
    </p>
  );
}
